/** Стан дзвінка, який бачить інтерфейс. */
export type CallPhase =
  | 'idle'
  | 'connecting'
  /** У кімнаті, але співрозмовника ще немає. */
  | 'waiting'
  /** У кімнаті бот-заглушка: показуємо відео, але це ще не співрозмовник. */
  | 'waiting-with-bot'
  | 'connected'
  | 'reconnecting'
  | 'ended';

export type CallEndReason =
  | 'local-hangup'
  | 'peer-left'
  | 'room-full'
  | 'invalid-room'
  | 'reconnect-failed'
  | 'time-expired'
  | 'media-denied'
  | 'media-unavailable'
  | 'connection-failed';

export interface PeerMediaState {
  micEnabled: boolean;
  videoEnabled: boolean;
}

export interface CallState {
  phase: CallPhase;
  roomId: string | null;
  /** Скільки спроб відновлення вже витрачено з бюджету. */
  reconnectAttempt: number;
  endReason: CallEndReason | null;
  peerMedia: PeerMediaState;
  hasRemoteVideo: boolean;
  /** true, поки в кімнаті бот-заглушка, а не жива людина. */
  peerIsBot: boolean;
}

export const initialCallState: CallState = {
  phase: 'idle',
  roomId: null,
  reconnectAttempt: 0,
  endReason: null,
  peerMedia: { micEnabled: true, videoEnabled: true },
  hasRemoteVideo: false,
  peerIsBot: false,
};

/** Префікс, за яким сервер позначає бота-заглушку. */
export const BOT_CLIENT_PREFIX = 'bot+';

export function isBotClientId(clientId: string): boolean {
  return clientId.startsWith(BOT_CLIENT_PREFIX);
}
